import script from "./AToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AToast.vue?vue&type=script&setup=true&lang=js"

import "./AToast.vue?vue&type=style&index=0&id=58aa4cea&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58aa4cea"]])

export default __exports__